'use strict';
import { observable, action } from 'mobx';
import { fetch, buildUrl, fetchBlob } from '@/lib/fetchAPI';

class TrafficReportStore {
  @observable trafficDate = [];
  @observable trafficDateTotal = 1;
  @observable page_num = 1;

  @action
  loadTrafficReport(start, end, traffic) {
    let param = buildUrl({
      page_size: 20,
      page_num: this.page_num,
      start: start,
      end: end,
      device_id: traffic
    });
    fetch(`/api/report/page/net${param}`, { method: 'GET' }, json => {
      this.trafficDate = json.content || [];
      this.trafficDateTotal = json.total;
    });
  }
  @action
  dowmloadReport(start, end, deviceId) {
    return fetchBlob(
      `/api/report/download/net?start=${start}&end=${end}&device_id=${
        deviceId
      }`,
      { method: 'GET' }
    ).then(blob => window.URL.createObjectURL(blob));
  }
}
export default new TrafficReportStore();



// WEBPACK FOOTER //
// ./src/store/TrafficReport/TrafficReport.js